// ***** Email Inbound Reducer *****/

import {
  EMAIL_INBOUND_GET_LIST,
  EMAIL_INBOUND_GET_LIST_SUCCESS,
  EMAIL_INBOUND_GET_LIST_ERROR,
  EMAIL_OUTBOUND_SEND_EMAIL,
  EMAIL_OUTBOUND_SEND_EMAIL_SUCCESS,
  EMAIL_OUTBOUND_SEND_EMAIL_ERROR,
  EMAIL_INBOUND_GET_SINGLE,
  EMAIL_INBOUND_GET_SINGLE_SUCCESS,
  EMAIL_INBOUND_GET_SINGLE_ERROR,
  EMAIL_INBOUND_ARCHIVE,
  EMAIL_INBOUND_ARCHIVE_SUCCESS,
  EMAIL_INBOUND_ARCHIVE_ERROR,
  EMAIL_INBOUND_MASS_MARKED_READ,
  EMAIL_INBOUND_MASS_MARKED_READ_SUCCESS,
  EMAIL_INBOUND_MASS_MARKED_READ_ERROR,
  EMAIL_INBOUND_UPDATE_STAFF,
  EMAIL_INBOUND_UPDATE_STAFF_SUCCESS,
  EMAIL_INBOUND_UPDATE_STAFF_ERROR,
  EMAIL_OUTBOUND_ACCOUNT_LIST,
  EMAIL_OUTBOUND_ACCOUNT_LIST_SUCCESS,
  EMAIL_OUTBOUND_ACCOUNT_LIST_ERROR,
  EMAIL_INBOUND_ARCHIVE_LIST,
  EMAIL_INBOUND_ARCHIVE_LIST_SUCCESS,
  EMAIL_INBOUND_ARCHIVE_LIST_ERROR,
  EMAIL_INBOUND_UNARCHIVE,
  EMAIL_INBOUND_UNARCHIVE_SUCCESS,
  EMAIL_INBOUND_UNARCHIVE_ERROR,
  EMAIL_INBOUND_MARK_AS_UNREAD,
  EMAIL_INBOUND_MARK_AS_UNREAD_SUCCESS,
  EMAIL_INBOUND_MARK_AS_UNREAD_ERROR,
  EMAIL_ACCOUNT_LIST,
  EMAIL_ACCOUNT_LIST_SUCCESS,
  EMAIL_ACCOUNT_LIST_ERROR,
  EMAIL_ACCOUNT_DETAILS,
  EMAIL_ACCOUNT_DETAILS_SUCCESS,
  EMAIL_ACCOUNT_DETAILS_ERROR,
  EMAIL_ACCOUNT_CREATE,
  EMAIL_ACCOUNT_CREATE_SUCCESS,
  EMAIL_ACCOUNT_CREATE_ERROR,
  EMAIL_ACCOUNT_UPDATE,
  EMAIL_ACCOUNT_UPDATE_SUCCESS,
  EMAIL_ACCOUNT_UPDATE_ERROR,
  EMAIL_ACCOUNT_DELETE,
  EMAIL_ACCOUNT_DELETE_SUCCESS,
  EMAIL_ACCOUNT_DELETE_ERROR,
  JOB_EMAIL_INBOUND_SEARCH,
  JOB_EMAIL_INBOUND_SEARCH_SUCCESS,
  JOB_EMAIL_INBOUND_SEARCH_ERROR,
  LINK_JOB_TO_EMAIL,
  LINK_JOB_TO_EMAIL_SUCCESS,
  LINK_JOB_TO_EMAIL_ERROR,
  EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK,
  EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_SUCCESS,
  EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_ERROR,
  EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS,
  EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_SUCCESS,
  EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_ERROR,
  EMAIL_TEMPLATE_LIST,
  EMAIL_TEMPLATE_LIST_SUCCESS,
  EMAIL_TEMPLATE_LIST_ERROR,
  EMAIL_TEMPLATE_SEARCH,
  EMAIL_TEMPLATE_SEARCH_SUCCESS,
  EMAIL_TEMPLATE_SEARCH_ERROR,
  EMAIL_TEMPLATE_DATA,
  EMAIL_TEMPLATE_DATA_SUCCESS,
  EMAIL_TEMPLATE_DATA_ERROR,
  EMAIL_TEMPLATE_CREATE,
  EMAIL_TEMPLATE_CREATE_SUCCESS,
  EMAIL_TEMPLATE_CREATE_ERROR,
  EMAIL_TEMPLATE_UPDATE,
  EMAIL_TEMPLATE_UPDATE_SUCCESS,
  EMAIL_TEMPLATE_UPDATE_ERROR,
  EMAIL_TEMPLATE_DELETE,
  EMAIL_TEMPLATE_DELETE_SUCCESS,
  EMAIL_TEMPLATE_DELETE_ERROR,
  EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED,
  EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED_SUCCESS,
  EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED_ERROR,
  EMAIL_DOMAIN_LIST,
  EMAIL_DOMAIN_LIST_SUCCESS,
  EMAIL_DOMAIN_LIST_ERROR,
  EMAIL_DOMAIN_DATA,
  EMAIL_DOMAIN_DATA_SUCCESS,
  EMAIL_DOMAIN_DATA_ERROR,
  EMAIL_DOMAIN_CREATE,
  EMAIL_DOMAIN_CREATE_SUCCESS,
  EMAIL_DOMAIN_CREATE_ERROR,
  EMAIL_DOMAIN_CHECK_DNS,
  EMAIL_DOMAIN_CHECK_DNS_SUCCESS,
  EMAIL_DOMAIN_CHECK_DNS_ERROR,
  EMAIL_DOMAIN_DELETE,
  EMAIL_DOMAIN_DELETE_SUCCESS,
  EMAIL_DOMAIN_DELETE_ERROR,
  EMAIL_INBOUND_REPLY_AUTOGENERATE,
  EMAIL_INBOUND_REPLY_AUTOGENERATE_SUCCESS,
  EMAIL_INBOUND_REPLY_AUTOGENERATE_ERROR,
  EMAIL_INBOUND_RULE_LIST,
  EMAIL_INBOUND_RULE_LIST_SUCCESS,
  EMAIL_INBOUND_RULE_LIST_ERROR,
  EMAIL_INBOUND_RULE_SEARCH,
  EMAIL_INBOUND_RULE_SEARCH_SUCCESS,
  EMAIL_INBOUND_RULE_SEARCH_ERROR,
  EMAIL_INBOUND_RULE_DATA,
  EMAIL_INBOUND_RULE_DATA_SUCCESS,
  EMAIL_INBOUND_RULE_DATA_ERROR,
  EMAIL_INBOUND_RULE_CREATE,
  EMAIL_INBOUND_RULE_CREATE_SUCCESS,
  EMAIL_INBOUND_RULE_CREATE_ERROR,
  EMAIL_INBOUND_RULE_UPDATE,
  EMAIL_INBOUND_RULE_UPDATE_SUCCESS,
  EMAIL_INBOUND_RULE_UPDATE_ERROR,
  EMAIL_INBOUND_RULE_DELETE,
  EMAIL_INBOUND_RULE_DELETE_SUCCESS,
  EMAIL_INBOUND_RULE_DELETE_ERROR,
  EMAIL_INBOUND_RULE_RUN,
  EMAIL_INBOUND_RULE_RUN_SUCCESS,
  EMAIL_INBOUND_RULE_RUN_ERROR,
  EMAIL_INBOUND_RULE_ITEM_FIELD_LIST,
  EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_SUCCESS,
  EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_ERROR,
  SYSTEM_FUNCTION_OPERAND_LIST,
  SYSTEM_FUNCTION_OPERAND_LIST_SUCCESS,
  SYSTEM_FUNCTION_OPERAND_LIST_ERROR,
} from "./actionType";

const INIT_STATE = {
  emailInboundList: [],
  emailInboundListLoading: false,
  loading: false,
  emailSendLoading: false,
  emailSend: [],
  emailInboundSingle: [],
  emailOutboundAccountList: [],
  archivedEmailList: [],
  email_staff_update_success: [],
  emailsArchiveSuccess: [],
  markedEmailsReadSuccess: [],
  archiveListloading: false,
  emailInboundSingleLoading: false,
  emailsUnarchiveSuccess: [],
  emailAccountsList: [],
  emailAccountsListLoading: false,
  emailAccountsDetails: [],
  emailAccountsDetailsLoading: false,
  emailAccountsCreate: [],
  emailAccountsCreateLoading: false,
  emailAccountsUpdate: [],
  emailAccountsUpdateLoading: false,
  emailAccountsDelete: [],
  emailAccountsDeleteLoading: false,
  jobEmailSearchData: [],
  jobEmailSearchLoading: false,
  linkToJobSuccess: [],
  linkToJobLoading: false,
  emailOutboundAddressBook: [],
  emailOutboundAddressBookLoading: false,
  emailOutboundAvailableAttachments: [],
  emailOutboundAvailableAttachmentsLoading: false,
  emailTemplateList: [],
  emailTemplateListLoading: false,
  emailTemplateSearch: [],
  emailTemplateSearchLoading: false,
  emailTemplateData: [],
  emailTemplateDataLoading: false,
  emailTemplateCreate: [],
  emailTemplateCreateLoading: false,
  emailTemplateUpdate: [],
  emailTemplateUpdateLoading: false,
  emailTemplateDelete: [],
  emailTemplateDeleteLoading: false,
  emailTemplateSendScheduled: [],
  emailTemplateSendScheduledLoading: false,
  emailDomainList: [],
  emailDomainListLoading: false,
  emailDomainData: [],
  emailDomainDataLoading: false,
  emailDomainCreate: [],
  emailDomainCreateLoading: false,
  emailDomainCheckDNS: [],
  emailDomainCheckDNSLoading: false,
  emailDomainDelete: [],
  emailDomainDeleteLoading: false,
  emailReplyAutogenerate: [],
  emailReplyAutogenerateLoading: false,
  emailInboundRuleList: [],
  emailInboundRuleListLoading: false,
  emailInboundRuleSearch: [],
  emailInboundRuleSearchLoading: false,
  emailInboundRuleData: [],
  emailInboundRuleDataLoading: false,
  emailInboundRuleCreate: [],
  emailInboundRuleCreateLoading: false,
  emailInboundRuleUpdate: [],
  emailInboundRuleUpdateLoading: false,
  emailInboundRuleDelete: [],
  emailInboundRuleDeleteLoading: false,
  emailInboundRuleRun: [],
  emailInboundRuleRunLoading: false,
  emailInboundRuleItemFieldList: [],
  emailInboundRuleItemFieldListLoading: false,
  systemFunctionOperandList: [],
  systemFunctionOperandListLoading: false,
};

const EmailInbound = (state = INIT_STATE, action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case EMAIL_INBOUND_GET_LIST:
      return { ...state, emailInboundListLoading: true };
    case EMAIL_INBOUND_GET_LIST_SUCCESS:
      return {
        ...state,
        emailInboundList: action.payload,
        emailInboundListLoading: false,
      };
    case EMAIL_INBOUND_GET_LIST_ERROR:
      return {
        ...state,
        emailInboundList: [],
        emailInboundListLoading: false,
      };
    case EMAIL_OUTBOUND_SEND_EMAIL:
      return { ...state, loading: true, emailSendLoading: true };

    case EMAIL_OUTBOUND_SEND_EMAIL_SUCCESS:
      return {
        ...state,
        emailSend: action.payload,
        loading: false,
        emailSendLoading: false,
      };
    case EMAIL_OUTBOUND_SEND_EMAIL_ERROR:
      return {
        ...state,
        emailSend: [],
        loading: false,
        emailSendLoading: false,
      };
    case EMAIL_INBOUND_GET_SINGLE:
      return {
        ...state,
        emailInboundSingle: action.payload,
        emailInboundSingleLoading: true,
      };
    case EMAIL_INBOUND_GET_SINGLE_SUCCESS:
      return {
        ...state,
        emailInboundSingle: action.payload,
        emailInboundSingleLoading: false,
      };
    case EMAIL_INBOUND_GET_SINGLE_ERROR:
      return {
        ...state,
        emailInboundSingle: [],
        emailInboundSingleLoading: false,
      };
    case EMAIL_INBOUND_ARCHIVE:
      return { ...state, emails: action.payload, loading: true };

    case EMAIL_INBOUND_ARCHIVE_SUCCESS:
      return {
        ...state,
        emailsArchiveSuccess: action.payload,
        loading: false,
      };
    case EMAIL_INBOUND_ARCHIVE_ERROR:
      return {
        ...state,
        emails: [],
        loading: false,
      };
    case EMAIL_INBOUND_MASS_MARKED_READ:
      return { ...state, markedEmails: action.payload, loading: true };
    case EMAIL_INBOUND_MASS_MARKED_READ_SUCCESS:
      return {
        ...state,
        markedEmailsReadSuccess: action.payload,
        loading: false,
      };
    case EMAIL_INBOUND_MASS_MARKED_READ_ERROR:
      return {
        ...state,
        markedEmails: [],
      };
    case EMAIL_INBOUND_UPDATE_STAFF:
      return { ...state, emails_Staff_update: action.payload, loading: true };
    case EMAIL_INBOUND_UPDATE_STAFF_SUCCESS:
      return {
        ...state,

        email_staff_update_success: action.payload,
        loading: false,
      };
    case EMAIL_INBOUND_UPDATE_STAFF_ERROR:
      return {
        ...state,
        emails_Staff_update: [],
        loading: false,
      };
    case EMAIL_OUTBOUND_ACCOUNT_LIST:
      return { ...state, loading: true };

    case EMAIL_OUTBOUND_ACCOUNT_LIST_SUCCESS:
      return {
        ...state,
        emailOutboundAccountList: action.payload,
        loading: false,
      };
    case EMAIL_OUTBOUND_ACCOUNT_LIST_ERROR:
      return {
        ...state,
        emailOutboundAccountList: [],
        loading: false,
      };
    case EMAIL_INBOUND_ARCHIVE_LIST:
      return { ...state, archiveListloading: true };
    case EMAIL_INBOUND_ARCHIVE_LIST_SUCCESS:
      return {
        ...state,
        archivedEmailList: action.payload,
        archiveListloading: false,
      };
    case EMAIL_INBOUND_ARCHIVE_LIST_ERROR:
      return {
        ...state,
        archiveListloading: false,
      };
    case EMAIL_INBOUND_UNARCHIVE:
      return { ...state, loading: true };
    case EMAIL_INBOUND_UNARCHIVE_SUCCESS:
      return {
        ...state,
        emailsUnarchiveSuccess: action.payload,
        loading: false,
      };
    case EMAIL_INBOUND_UNARCHIVE_ERROR:
      return {
        ...state,
        emailsUnarchiveSuccess: [],
      };
    case EMAIL_INBOUND_MARK_AS_UNREAD:
      return { ...state, loading: true };
    case EMAIL_INBOUND_MARK_AS_UNREAD_SUCCESS:
      return {
        ...state,
        emailsUnreadSuccess: action.payload,
        loading: false,
      };
    case EMAIL_INBOUND_MARK_AS_UNREAD_ERROR:
      return {
        ...state,
        emailsUnreadSuccess: [],
      };
    case EMAIL_ACCOUNT_LIST:
      return { ...state, emailAccountsListLoading: true };
    case EMAIL_ACCOUNT_LIST_SUCCESS:
      return {
        ...state,
        emailAccountsList: action.payload,
        emailAccountsListLoading: false,
      };
    case EMAIL_ACCOUNT_LIST_ERROR:
      return {
        ...state,
        emailAccountsList: [],
        emailAccountsListLoading: false,
      };
    case EMAIL_ACCOUNT_DETAILS:
      return { ...state, emailAccountsDetailsLoading: true };
    case EMAIL_ACCOUNT_DETAILS_SUCCESS:
      return {
        ...state,
        emailAccountsDetails: action.payload,
        emailAccountsDetailsLoading: false,
      };
    case EMAIL_ACCOUNT_DETAILS_ERROR:
      return {
        ...state,
        emailAccountsDetails: [],
        emailAccountsDetailsLoading: false,
      };
    case EMAIL_ACCOUNT_CREATE:
      return { ...state, emailAccountsCreateLoading: true };
    case EMAIL_ACCOUNT_CREATE_SUCCESS:
      return {
        ...state,
        emailAccountsCreate: action.payload,
        emailAccountsCreateLoading: false,
      };
    case EMAIL_ACCOUNT_CREATE_ERROR:
      return {
        ...state,
        emailAccountsCreate: [],
        emailAccountsCreateLoading: false,
      };
    case EMAIL_ACCOUNT_UPDATE:
      return { ...state, emailAccountsUpdateLoading: true };
    case EMAIL_ACCOUNT_UPDATE_SUCCESS:
      return {
        ...state,
        emailAccountsUpdate: action.payload,
        emailAccountsUpdateLoading: false,
      };
    case EMAIL_ACCOUNT_UPDATE_ERROR:
      return {
        ...state,
        emailAccountsUpdate: [],
        emailAccountsUpdateLoading: false,
      };
    case EMAIL_ACCOUNT_DELETE:
      return { ...state, emailAccountsDeleteLoading: true };
    case EMAIL_ACCOUNT_DELETE_SUCCESS:
      return {
        ...state,
        emailAccountsDelete: action.payload,
        emailAccountsDeleteLoading: false,
      };
    case EMAIL_ACCOUNT_DELETE_ERROR:
      return {
        ...state,
        emailAccountsDelete: [],
        emailAccountsDeleteLoading: false,
      };
    case JOB_EMAIL_INBOUND_SEARCH:
      return { ...state, jobEmailSearchLoading: true };
    case JOB_EMAIL_INBOUND_SEARCH_SUCCESS:
      return {
        ...state,
        jobEmailSearchData: action.payload,
        jobEmailSearchLoading: false,
      };
    case JOB_EMAIL_INBOUND_SEARCH_ERROR:
      return {
        ...state,
        jobEmailSearchData: [],
        jobEmailSearchLoading: false,
      };
    case LINK_JOB_TO_EMAIL:
      return { ...state, linkToJobLoading: true };
    case LINK_JOB_TO_EMAIL_SUCCESS:
      return {
        ...state,
        linkToJobSuccess: action.payload,
        linkToJobLoading: false,
      };
    case LINK_JOB_TO_EMAIL_ERROR:
      return {
        ...state,
        linkToJobSuccess: [],
        linkToJobLoading: false,
      };
    case EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK:
      return { ...state, emailOutboundAddressBookLoading: true };
    case EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_SUCCESS:
      return {
        ...state,
        emailOutboundAddressBook: action.payload,
        emailOutboundAddressBookLoading: false,
      };
    case EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_ERROR:
      return {
        ...state,
        emailOutboundAddressBook: [],
        emailOutboundAddressBookLoading: false,
      };
    case EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS:
      return { ...state, emailOutboundAvailableAttachmentsLoading: true };
    case EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_SUCCESS:
      return {
        ...state,
        emailOutboundAvailableAttachments: action.payload,
        emailOutboundAvailableAttachmentsLoading: false,
      };
    case EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_ERROR:
      return {
        ...state,
        emailOutboundAvailableAttachments: [],
        emailOutboundAvailableAttachmentsLoading: false,
      };
    case EMAIL_TEMPLATE_LIST:
      return { ...state, emailTemplateListLoading: true };
    case EMAIL_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        emailTemplateList: action.payload,
        emailTemplateListLoading: false,
      };
    case EMAIL_TEMPLATE_LIST_ERROR:
      return {
        ...state,
        emailTemplateList: [],
        emailTemplateListLoading: false,
      };
    case EMAIL_TEMPLATE_SEARCH:
      return { ...state, emailTemplateSearchLoading: true };
    case EMAIL_TEMPLATE_SEARCH_SUCCESS:
      return {
        ...state,
        emailTemplateSearch: action.payload,
        emailTemplateSearchLoading: false,
      };
    case EMAIL_TEMPLATE_SEARCH_ERROR:
      return {
        ...state,
        emailTemplateSearch: [],
        emailTemplateSearchLoading: false,
      };
    case EMAIL_TEMPLATE_DATA:
      return { ...state, emailTemplateDataLoading: true };
    case EMAIL_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        emailTemplateData: action.payload,
        emailTemplateDataLoading: false,
      };
    case EMAIL_TEMPLATE_DATA_ERROR:
      return {
        ...state,
        emailTemplateData: [],
        emailTemplateDataLoading: false,
      };
    case EMAIL_TEMPLATE_CREATE:
      return { ...state, emailTemplateCreateLoading: true };
    case EMAIL_TEMPLATE_CREATE_SUCCESS:
      return {
        ...state,
        emailTemplateCreate: action.payload,
        emailTemplateCreateLoading: false,
      };
    case EMAIL_TEMPLATE_CREATE_ERROR:
      return {
        ...state,
        emailTemplateCreate: [],
        emailTemplateCreateLoading: false,
      };
    case EMAIL_TEMPLATE_UPDATE:
      return { ...state, emailTemplateUpdateLoading: true };
    case EMAIL_TEMPLATE_UPDATE_SUCCESS:
      return {
        ...state,
        emailTemplateUpdate: action.payload,
        emailTemplateUpdateLoading: false,
      };
    case EMAIL_TEMPLATE_UPDATE_ERROR:
      return {
        ...state,
        emailTemplateUpdate: [],
        emailTemplateUpdateLoading: false,
      };
    case EMAIL_TEMPLATE_DELETE:
      return { ...state, emailTemplateDeleteLoading: true };
    case EMAIL_TEMPLATE_DELETE_SUCCESS:
      return {
        ...state,
        emailTemplateDelete: action.payload,
        emailTemplateDeleteLoading: false,
      };
    case EMAIL_TEMPLATE_DELETE_ERROR:
      return {
        ...state,
        emailTemplateDelete: [],
        emailTemplateDeleteLoading: false,
      };
    case EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED:
      return { ...state, emailTemplateSendScheduledLoading: true };
    case EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED_SUCCESS:
      return {
        ...state,
        emailTemplateSendScheduled: action.payload,
        emailTemplateSendScheduledLoading: false,
      };
    case EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED_ERROR:
      return {
        ...state,
        emailTemplateSendScheduled: [],
        emailTemplateSendScheduledLoading: false,
      };
    case EMAIL_DOMAIN_LIST:
      return { ...state, emailDomainListLoading: true };
    case EMAIL_DOMAIN_LIST_SUCCESS:
      return {
        ...state,
        emailDomainList: action.payload,
        emailDomainListLoading: false,
      };
    case EMAIL_DOMAIN_LIST_ERROR:
      return {
        ...state,
        emailDomainList: [],
        emailDomainListLoading: false,
      };
    case EMAIL_DOMAIN_DATA:
      return { ...state, emailDomainDataLoading: true };
    case EMAIL_DOMAIN_DATA_SUCCESS:
      return {
        ...state,
        emailDomainData: action.payload,
        emailDomainDataLoading: false,
      };
    case EMAIL_DOMAIN_DATA_ERROR:
      return {
        ...state,
        emailDomainData: [],
        emailDomainDataLoading: false,
      };
    case EMAIL_DOMAIN_CREATE:
      return { ...state, emailDomainCreateLoading: true };
    case EMAIL_DOMAIN_CREATE_SUCCESS:
      return {
        ...state,
        emailDomainCreate: action.payload,
        emailDomainCreateLoading: false,
      };
    case EMAIL_DOMAIN_CREATE_ERROR:
      return {
        ...state,
        emailDomainCreate: [],
        emailDomainCreateLoading: false,
      };
    case EMAIL_DOMAIN_CHECK_DNS:
      return { ...state, emailDomainCheckDNSLoading: true };
    case EMAIL_DOMAIN_CHECK_DNS_SUCCESS:
      return {
        ...state,
        emailDomainCheckDNS: action.payload,
        emailDomainCheckDNSLoading: false,
      };
    case EMAIL_DOMAIN_CHECK_DNS_ERROR:
      return {
        ...state,
        emailDomainCheckDNS: [],
        emailDomainCheckDNSLoading: false,
      };
    case EMAIL_DOMAIN_DELETE:
      return { ...state, emailDomainDeleteLoading: true };
    case EMAIL_DOMAIN_DELETE_SUCCESS:
      return {
        ...state,
        emailDomainDelete: action.payload,
        emailDomainDeleteLoading: false,
      };
    case EMAIL_DOMAIN_DELETE_ERROR:
      return {
        ...state,
        emailDomainDelete: [],
        emailDomainDeleteLoading: false,
      };
    case EMAIL_INBOUND_REPLY_AUTOGENERATE:
      return { ...state, emailReplyAutogenerateLoading: true };
    case EMAIL_INBOUND_REPLY_AUTOGENERATE_SUCCESS:
      return {
        ...state,
        emailReplyAutogenerate: action.payload,
        emailReplyAutogenerateLoading: false,
      };
    case EMAIL_INBOUND_REPLY_AUTOGENERATE_ERROR:
      return {
        ...state,
        emailReplyAutogenerate: [],
        emailReplyAutogenerateLoading: false,
      };

    // ***** Email Inbound Rule ***** //
    case EMAIL_INBOUND_RULE_LIST:
      return { ...state, emailInboundRuleListLoading: true };
    case EMAIL_INBOUND_RULE_LIST_SUCCESS:
      return {
        ...state,
        emailInboundRuleList: action.payload,
        emailInboundRuleListLoading: false,
      };
    case EMAIL_INBOUND_RULE_LIST_ERROR:
      return {
        ...state,
        emailInboundRuleList: [],
        emailInboundRuleListLoading: false,
      };
    case EMAIL_INBOUND_RULE_SEARCH:
      return { ...state, emailInboundRuleSearchLoading: true };
    case EMAIL_INBOUND_RULE_SEARCH_SUCCESS:
      return {
        ...state,
        emailInboundRuleSearch: action.payload,
        emailInboundRuleSearchLoading: false,
      };
    case EMAIL_INBOUND_RULE_SEARCH_ERROR:
      return {
        ...state,
        emailInboundRuleSearch: [],
        emailInboundRuleSearchLoading: false,
      };
    case EMAIL_INBOUND_RULE_DATA:
      return { ...state, emailInboundRuleDataLoading: true };
    case EMAIL_INBOUND_RULE_DATA_SUCCESS:
      return {
        ...state,
        emailInboundRuleData: action.payload,
        emailInboundRuleDataLoading: false,
      };
    case EMAIL_INBOUND_RULE_DATA_ERROR:
      return {
        ...state,
        emailInboundRuleData: [],
        emailInboundRuleDataLoading: false,
      };
    case EMAIL_INBOUND_RULE_CREATE:
      return { ...state, emailInboundRuleCreateLoading: true };
    case EMAIL_INBOUND_RULE_CREATE_SUCCESS:
      return {
        ...state,
        emailInboundRuleCreate: action.payload,
        emailInboundRuleCreateLoading: false,
      };
    case EMAIL_INBOUND_RULE_CREATE_ERROR:
      return {
        ...state,
        emailInboundRuleCreate: [],
        emailInboundRuleCreateLoading: false,
      };
    case EMAIL_INBOUND_RULE_UPDATE:
      return { ...state, emailInboundRuleUpdateLoading: true };
    case EMAIL_INBOUND_RULE_UPDATE_SUCCESS:
      return {
        ...state,
        emailInboundRuleUpdate: action.payload,
        emailInboundRuleUpdateLoading: false,
      };
    case EMAIL_INBOUND_RULE_UPDATE_ERROR:
      return {
        ...state,
        emailInboundRuleUpdate: [],
        emailInboundRuleUpdateLoading: false,
      };
    case EMAIL_INBOUND_RULE_DELETE:
      return { ...state, emailInboundRuleDeleteLoading: true };
    case EMAIL_INBOUND_RULE_DELETE_SUCCESS:
      return {
        ...state,
        emailInboundRuleDelete: action.payload,
        emailInboundRuleDeleteLoading: false,
      };
    case EMAIL_INBOUND_RULE_DELETE_ERROR:
      return {
        ...state,
        emailInboundRuleDelete: [],
        emailInboundRuleDeleteLoading: false,
      };
    case EMAIL_INBOUND_RULE_RUN:
      return { ...state, emailInboundRuleRunLoading: true };
    case EMAIL_INBOUND_RULE_RUN_SUCCESS:
      return {
        ...state,
        emailInboundRuleRun: action.payload,
        emailInboundRuleRunLoading: false,
      };
    case EMAIL_INBOUND_RULE_RUN_ERROR:
      return {
        ...state,
        emailInboundRuleRun: [],
        emailInboundRuleRunLoading: false,
      };
    case EMAIL_INBOUND_RULE_ITEM_FIELD_LIST:
      return { ...state, emailInboundRuleItemFieldListLoading: true };
    case EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_SUCCESS:
      return {
        ...state,
        emailInboundRuleItemFieldList: action.payload,
        emailInboundRuleItemFieldListLoading: false,
      };
    case EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_ERROR:
      return {
        ...state,
        emailInboundRuleItemFieldList: [],
        emailInboundRuleItemFieldListLoading: false,
      };
    case SYSTEM_FUNCTION_OPERAND_LIST:
      return { ...state, systemFunctionOperandListLoading: true };
    case SYSTEM_FUNCTION_OPERAND_LIST_SUCCESS:
      return {
        ...state,
        systemFunctionOperandList: action.payload,
        systemFunctionOperandListLoading: false,
      };
    case SYSTEM_FUNCTION_OPERAND_LIST_ERROR:
      return {
        ...state,
        systemFunctionOperandList: [],
        systemFunctionOperandListLoading: false,
      };

    default:
      return state;
  }
};

export default EmailInbound;
